export class ProductInquiryController {
  constructor({ toast }) {
    this.toast = toast;
    this.form = document.querySelector(".js-product-inquiry-form");
    this.variantInput = document.querySelector(".js-selected-variant-id");
    this.variantItems = Array.from(document.querySelectorAll(".js-product-variant"));
    this.bind();
  }

  bind() {
    if (!this.form) return;

    const nameEl = this.form.querySelector(".js-inquiry-name");
    const emailEl = this.form.querySelector(".js-inquiry-email");
    const phoneEl = this.form.querySelector(".js-inquiry-phone");
    const messageEl = this.form.querySelector(".js-inquiry-message");
    const kvkkEl = this.form.querySelector(".js-inquiry-kvkk");
    const websiteEl = this.form.querySelector(".js-inquiry-website");
    const submitEl = this.form.querySelector(".js-inquiry-submit");
    const statusEl = this.form.querySelector(".js-inquiry-status");

    this.form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const fullName = (nameEl?.value || "").trim();
      const email = (emailEl?.value || "").trim();
      const phone = (phoneEl?.value || "").trim();
      const message = (messageEl?.value || "").trim();
      const kvkk = Boolean(kvkkEl?.checked);
      const website = (websiteEl?.value || "").trim();

      if (!fullName || !email || !message || !kvkk) {
        this.toast("Lütfen zorunlu alanları doldurun.", "error");
        return;
      }

      const productId = Number(this.form.dataset.productId || 0);
      const productTitle = this.form.dataset.productTitle || "Ürün";
      const productUrl = this.form.dataset.productUrl || window.location.href;
      const variantId = this.variantInput?.value || "";
      const selectedVariant = this.variantItems.find((item) => item.dataset.variantId === variantId);

      if (submitEl) submitEl.disabled = true;
      if (statusEl) statusEl.textContent = "Gönderiliyor...";

      try {
        const payload = {
          full_name: fullName,
          email,
          phone,
          subject: `${productTitle} için teklif talebi`,
          message,
          source_type: "product_inquiry",
          source_id: productId || null,
          source_url: productUrl,
          metadata: {
            product_id: productId || null,
            product_title: productTitle,
            variant_id: variantId ? Number(variantId) : null,
            variant_name: selectedVariant?.dataset.variantName || "",
          },
          kvkk_consent: kvkk,
          website,
        };

        const res = await fetch("/api/contact-requests/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) throw new Error("request_failed");

        this.form.reset();
        if (statusEl) statusEl.textContent = "Talebiniz alındı, en kısa sürede dönüş yapacağız.";
        this.toast("Talebiniz başarıyla gönderildi.", "success");
      } catch {
        if (statusEl) statusEl.textContent = "Gönderim sırasında hata oluştu.";
        this.toast("Gönderim başarısız. Lütfen tekrar deneyin.", "error");
      } finally {
        if (submitEl) submitEl.disabled = false;
      }
    });
  }
}
